import { AxiosError } from 'axios';

import { CONSULTANT_INDUSTRIES_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ConsultantIndustries } from '@/types/consultant.type';
import { ApiResponse } from '@/types/response.type';

export const getConsultantIndustries = async (): Promise<
  ApiResponse<ConsultantIndustries>
> => {
  try {
    const response = await apiManager.get(CONSULTANT_INDUSTRIES_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
